import { Pipe, PipeTransform } from '@angular/core';
import { fmtRM } from '../utils/money';

/** Ringgit money format: 'RM ' + locale thousands with 2 decimals. e.g. 1500 → 'RM 1,500.00'. */
@Pipe({ name: 'rm', standalone: true })
export class RmPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    return fmtRM(value);
  }
}
